"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getTeamPage = void 0;
var teams_1 = require("../configs/teams");
var getTeamPage = function (team) {
    return teams_1.teamPage[team];
};
exports.getTeamPage = getTeamPage;
